/**课程详情按钮类型*/
export enum CourseButtonTypes {
  时间卡预约按钮 = 1,
  常规课预约按钮 = 2,
  登录按钮 = 3,
  等位按钮 = 4,
  已满按钮 = 5,
  已报名按钮 = 6,
  报名结束按钮 = 7,
  难度不适用按钮 = 8,
  立即报名按钮 = 9,
  时间卡等位按钮 = 10,
  已等位按钮 = 11,
  等位已满 = 12,
  等位结束 = 13
}

/**课程类型*/
export enum COURSE_TYPES {
  TYPE_SEMESTER_COURSE = 1, //学期课
  TYPE_TRAINING = 2, //集训课(默认3天)
  TYPE_SINGLE = 3, //单次课
  TYPE_SALON = 4, //沙龙课
  TYPE_SHORT = 5, //短期课
  TYPE_PRIVATE = 6, //私教课
  TYPE_SELECTED_PRIVATE = 7, //特选私教课
  TYPE_THEME = 8, //主题课
  TYPE_LIVE = 9, // 直播课
  TYPE_TRAINING_FIVE = 10, //5天集训课
  TYPE_SHOW = 11, //比赛演出
  TYPE_PUBLIC_LIVE = 12,//公开直播课
}

export enum COURSE_TYPE_NAMES {
  TYPE_SEMESTER_COURSE = '学期课',
  TYPE_TRAINING = '3天集训', //集训课(默认3天)
  TYPE_SINGLE = '单次课', //单次课
  TYPE_SALON = '沙龙课', //沙龙课
  TYPE_SHORT = '短期课', //短期课
  TYPE_PRIVATE = '私教课', //私教课
  TYPE_SELECTED_PRIVATE = '特选私教课', //特选私教课
  TYPE_THEME = '主题课', //主题课
  TYPE_LIVE = '主播课', // 直播课
  TYPE_TRAINING_FIVE = '五天集训', //5天集训课
  TYPE_SHOW = '比赛演出', //比赛演出
  TYPE_PUBLIC_LIVE = '网络课',//公开直播课
}


export enum COURSE_ID {
  中级变奏 = 44,
  足尖初级 = 45,
  中级提升 = 46,
  短期入门 = 47,
  初级技巧 = 48,
  足尖入门 = 49,
  中级芭蕾 = 50,
  中级预备 = 51,
  初级常规 = 52,
  软开素质 = 53,
  初级三阶 = 54,
  初级二阶 = 55,
  初级一阶 = 56,
  芭蕾入门 = 57,
  脚背加强 = 58,
  体验课 = 59,
  地面练习 = 60,
  短期剧目 = 61,
  现代芭蕾 = 62,
  短期一阶 = 63,
  短期二阶 = 64,
  短期三阶 = 65,
  舞姿强化 = 66,
  内侧强化 = 67,
  足尖中级 = 68,
  剧目入门 = 69,
  三阶加强 = 70,
  初级变奏 = 72,
  中级技巧 = 73,
  零基础公开课 = 74,
  天鹅肩臂 = 76,
  芭蕾体态养成 = 77,
  常规加强 = 78,
  入门加强 = 79,
  一阶加强 = 80,
  二阶加强 = 81,
  三阶加强_单次 = 82,
  平衡能力提升_短期 = 83,
  平衡能力提升 = 110,
  核心强化 = 84,
  足尖零基础 = 85,
  足尖零基础_短期 = 120,
  软开素质_短期 = 126,
  技巧入门_短期 = 139,
  短期变奏 = 189,
  足尖入门_短期 = 193,
  天鹅肩臂_短期 = 194,
  舞姿强化_短期 = 196,
  足尖初级_短期 = 217,
  精品班 = 224
}


